import React from 'react';
import MuiCheckbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: theme.typography.body2.fontSize,
  },
}));

type IProps = CheckboxProps & {
  label?: React.ReactNode;
};

export const RawCheckbox: React.FunctionComponent<IProps> = ({
  label,
  disabled = false,
  classes,
  ...props
}: IProps) => {
  const customClasses = useStyles();
  const mergedClasses = { ...customClasses, ...classes };

  if (label) {
    return (
      <FormControlLabel
        control={<MuiCheckbox {...props} />}
        label={label}
        classes={mergedClasses}
        disabled={disabled}
      />
    );
  }
  return <MuiCheckbox disabled={disabled} classes={classes} {...props} />;
};
